/**
 * ALWAYS ADD FROM THE END
 */
const InsightsPreferences = {
    options: [
        { value: 'channel', label: 'Channel', selected: true },
        { value: 'priority', label: 'Source', selected: true },
        { value: 'from', label: 'Sender', selected: true },
        { value: 'to', label: 'Phone', selected: true },
        { value: 'country', label: 'Country', selected: true },
        { value: 'text', label: 'Message', selected: true },
        { value: 'segment_count', label: 'Segments', selected: false },
        { value: 'price', label: 'Price', selected: true },
        { value: 'direction', label: 'Type', selected: false },
        { value: 'create_date', label: 'Date', selected: true },
        { value: 'status', label: 'Status', selected: true },
        { value: 'verification_status', label: 'Code Status', selected: true },
        { value: 'wa_category', label: 'WhatsApp Category', selected: false },
        { value: 'network', label: 'Mobile Network', selected: false },
        { value: 'mccmnc', label: 'MCC/MNC', selected: false },
    ],
    total: 15,
    count: 10,
    perPage: 10,
};

const TemplatesPreferences = {
    options: [
        { value: 'channel', label: 'Channel', selected: true },
        { value: 'name', label: 'Name', selected: true },
        { value: 'text', label: 'Message', selected: true },
        { value: 'status', label: 'Status', selected: true },
        { value: 'create_date', label: 'Created Date', selected: true },
        { value: 'wa_category', label: 'WhatsApp Category', selected: true },
        { value: 'wa_sender_code', label: 'WhatsApp Sender', selected: true },
    ],
    total: 7,
    count: 7,
    perPage: 10,
};

export const TEMPLATE_TABLE_HEADERS: any = {
    channel: 'Channel',
    name: 'Name',
    text: 'Message',
    to: 'Phone',
    status: 'Status',
    create_date: 'Created Date',
    wa_category: 'WhatsApp Category',
    wa_sender_code: 'WhatsApp Sender',
};

const OnboardingPreferences = {
    skip: false,
    messageSent: false,
    senderRequested: false,
    audienceCreated: false,
    templateCreated: false,
    inboxEnabled: false,
    chartsPeriod: { value: 6, label: '7 days' },
};

export const preferencesInternal: any = {
    insights: InsightsPreferences,
    templates: TemplatesPreferences,
    onboarding: OnboardingPreferences,
};
